import { Layout } from "antd";

const { Content } = Layout;

export default function ContentWrapper({ children, sidebarWidth = 0 }) {
  const HEADER_HEIGHT = 64;

  return (
    <Content
      className="app-content"
      style={{
        marginLeft: sidebarWidth,
        paddingTop: HEADER_HEIGHT + 24,
        transition: "margin-left 0.4s ease",
        minHeight: "100vh",
      }}
    >
      <div className="bodyContentWrap">{children}</div>

      <footer className="siteFooter">© Copyright PingInvite 2025</footer>
    </Content>
  );
}
